import { render } from "./PreferencesScreen.vue?vue&type=template&id=1d9c52a1&scoped=true"
import script from "./PreferencesScreen.vue?vue&type=script&lang=js"
export * from "./PreferencesScreen.vue?vue&type=script&lang=js"

import "./PreferencesScreen.vue?vue&type=style&index=0&id=1d9c52a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9c52a1"]])

export default __exports__